/**
 * Centers an aplus_row.overlay_image on the row's visible photo, not on the
 * whole media box. On a card-slider row the text card sits inside the same
 * box as the photo and its height is content-driven (and differs per slide),
 * so CSS alone cannot find the photo's midpoint — this measures it and hands
 * the result back to CSS as --aplus-overlay-center on the stage.
 *
 * Markup contract (built by sections/atomberg-aplus-content.liquid):
 *   .atomberg-aplus__overlay-stage
 *     (row media; optionally containing .atomberg-auto-slideshow__track with
 *      per-slide .atomberg-aplus__text-block cards)
 *     img.atomberg-aplus__row-overlay
 *
 * Runs again on every execution: the variant picker swaps the A+ section via
 * innerHTML and re-inserts this script tag, so a fresh stage must be scanned
 * even though the listeners below are already registered.
 */
(function () {
  /** @type {any} */
  var w = window;

  var STAGE = '.atomberg-aplus__overlay-stage';
  var TRACK = '.atomberg-auto-slideshow__track';
  var CARD = '.atomberg-auto-slideshow__slide .atomberg-aplus__text-block';

  /**
   * @param {HTMLElement} stage
   */
  function measure(stage) {
    /** @type {HTMLElement | null} */
    var track = stage.querySelector(TRACK);
    var box = track || stage;
    var stageTop = stage.getBoundingClientRect().top;
    var boxRect = box.getBoundingClientRect();

    // The photo is the part of the box the tallest card does not cover.
    var cardHeight = 0;
    box.querySelectorAll(CARD).forEach(function (card) {
      cardHeight = Math.max(cardHeight, /** @type {HTMLElement} */ (card).offsetHeight);
    });

    var photoTop = boxRect.top - stageTop;
    var photoHeight = Math.max(boxRect.height - cardHeight, 0);
    var center = photoTop + photoHeight / 2;
    stage.style.setProperty('--aplus-overlay-center', Math.round(center) + 'px');
    // Lets CSS cap the overlay's height against the photo, not the viewport
    // width — a landscape photo on a narrow screen is short, and a width-only
    // size would otherwise overflow it.
    stage.style.setProperty('--aplus-overlay-photo-height', Math.round(photoHeight) + 'px');
  }

  /**
   * @param {HTMLElement} stage
   */
  function init(stage) {
    if (stage.dataset.atombergOverlayInit === 'true') return;
    stage.dataset.atombergOverlayInit = 'true';

    var run = function () {
      measure(stage);
    };
    run();

    if ('ResizeObserver' in w) {
      var ro = new ResizeObserver(run);
      ro.observe(stage);
      // Cards live inside the fixed-aspect track, so a card growing (font
      // load, longer tagline) never resizes the stage itself — watch them too.
      stage.querySelectorAll(CARD).forEach(function (card) {
        ro.observe(card);
      });
    } else {
      w.addEventListener('resize', run);
    }
  }

  function scan() {
    document.querySelectorAll(STAGE).forEach(function (stage) {
      init(/** @type {HTMLElement} */ (stage));
    });
  }

  if (w._atombergAplusOverlayInit) {
    scan();
    return;
  }
  w._atombergAplusOverlayInit = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();
